import { useFetch } from '../lib/useFetch';
import { formatFcfa } from '../lib/labels';

interface PlatformSettings {
  commissionRate: number;
  minRechargeFcfa: number;
  maxRechargeFcfa: number;
}

export default function Settings() {
  const settings = useFetch<PlatformSettings>('/admin/settings');

  return (
    <div className="page-transition">
      <div className="container pt-6">
        <div className="page-head">
          <div>
            <h1 className="page-title">Paramètres</h1>
            <p className="page-subtitle">Réglages actuels de la plateforme (lecture seule)</p>
          </div>
        </div>

        {settings.isLoading ? (
          <div className="card"><div className="state-box"><span className="loading-spinner" /></div></div>
        ) : settings.error ? (
          <div className="card"><div className="state-box">{settings.error}</div></div>
        ) : settings.data ? (
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-card-header"><span className="stat-card-title">Commission plateforme</span></div>
              <div className="stat-card-value">{Math.round(settings.data.commissionRate * 100)} %</div>
            </div>
            <div className="stat-card">
              <div className="stat-card-header"><span className="stat-card-title">Recharge minimum</span></div>
              <div className="stat-card-value">{formatFcfa(settings.data.minRechargeFcfa)}</div>
            </div>
            <div className="stat-card">
              <div className="stat-card-header"><span className="stat-card-title">Recharge maximum</span></div>
              <div className="stat-card-value">{formatFcfa(settings.data.maxRechargeFcfa)}</div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
